<template>
	<div>
		<CRow>
			<CCol col="4">
				<CInput name="reference" label="Référence du produit" :value="item.reference" disabled />
			</CCol>
			<CCol col="8">
				<CInput name="name" label="Nom" :value="item.name" />
			</CCol>
		</CRow>

		<hr />

		<CRow>
			<CCol col="6">
				<CInput name="price" label="Tarif HT" :value="item.price" horizontal>
					<template #append-content><CIcon name="cil-euro" /></template>
				</CInput>
			</CCol>
		</CRow>

		<hr />

		<CRow>
			<CCol col="6">
				<CInput label="Largeur" name="width" :value="item.width" horizontal append="CM" />
			</CCol>
			<CCol col="6">
				<CInput label="Hauteur" name="height" :value="item.height" horizontal append="CM" />
			</CCol>
			<CCol col="6">
				<CInput label="Profondeur" name="depth" :value="item.depth" horizontal append="CM" />
			</CCol>
			<hr />
			<CCol col="6">
				<CInput label="Unité volume" name="uv" :value="item.uv" horizontal append="UV" />
			</CCol>
		</CRow>

		<CRow>
			<CCol col="6">
				<CInput
					label="Poids brute"
					name="weightGross"
					:value="item.weightGross"
					horizontal
					append="KG" />
			</CCol>
			<CCol col="6">
				<CInput label="Poids net" name="weightNet" :value="item.weightNet" horizontal append="KG" />
			</CCol>
		</CRow>

		<hr />

		<CRow>
			<CCol sm="6">
				<GSwitchSmall name="active" label="Active" :checked="item.active" />
			</CCol>
		</CRow>
	</div>
</template>

<script>
	import GSwitchSmall from '../../../../components/ghostlexly-components/GSwitchSmall';

	export default {
		name: 'FormModal',

		components: {
			GSwitchSmall,
		},

		props: {
			item: {
				type: Object,
				default: () => {
					return {};
				},
			},
		},

		data() {
			return {};
		},
	};
</script>
